import { FundDonateButton } from "~/common/fund/FundDonateButton";

export const FundViewTitle = ({
  title,
  onClick,
}: {
  title?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  return (
    <div className="tw:flex tw:justify-between tw:items-center tw:py-2">
      <div className="tw:text-[#001936] tw:text-[1.75rem] tw:lg:text-[3rem] tw:font-semibold">
        {title}
      </div>
      <div>
        <FundDonateButton onClick={onClick} />
      </div>
    </div>
  );
};
